import React from 'react'

const Home = () => {
  return (
    <div className='home'>
        <div className='homeh'>
        <button className='btnhome'>LET US HELP YOUR PLAN</button>
        </div>
    </div>
  )
}

export default Home;
